import React from "react";
import LoginForm from "../../components/LoginForm/LoginForm";

const Login = () => {
  return (
    <section className="section">
      <div className="container" style={{ width: 300 }}>
        <LoginForm />
      </div>
    </section>
  );
};

export default Login;
